import React, { useState, useEffect } from 'react';
import s from './adminStyles';
import { authHeaders } from '../../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ImportPanel = () => {
  const [importStatus, setImportStatus] = useState(null);
  const [importing, setImporting] = useState(false);

  useEffect(() => { loadStatus(); }, []);

  const loadStatus = () => {
    fetch(`${API_URL}/api/import/status`, { headers: authHeaders() })
      .then(r => r.json())
      .then(setImportStatus)
      .catch(console.error);
  };

  const handleImport = () => {
    setImporting(true);
    fetch(`${API_URL}/api/import/nelemans?max_properties=10`, { method: 'POST', headers: authHeaders() })
      .then(r => r.json())
      .then(d => {
        alert(`Import succesvol! ${d.imported} nieuwe woningen toegevoegd, ${d.skipped} overgeslagen.`);
        loadStatus();
      })
      .catch(err => alert('Import mislukt: ' + err.message))
      .finally(() => setImporting(false));
  };

  return (
    <div>
      <h2 style={s.sectionTitle}>Import van Nelemans</h2>

      {importStatus && (
        <div style={s.importStatusCard}>
          <h3 style={s.statusTitle}>Huidige Status</h3>
          <div style={s.statusGrid}>
            <div style={s.statusItem}>
              <span style={s.statusLabel}>Totaal woningen</span>
              <span style={s.statusValue}>{importStatus.total_properties}</span>
            </div>
            <div style={s.statusItem}>
              <span style={s.statusLabel}>Nelemans woningen</span>
              <span style={s.statusValue}>{importStatus.nelemans_properties}</span>
            </div>
          </div>
        </div>
      )}

      <div style={s.importCard}>
        <h3 style={s.importTitle}>Importeer Woningen van Nelemans</h3>
        <p style={s.importText}>
          Klik op de knop hieronder om automatisch woningen te importeren van de Nelemans website.
          Het systeem zal de laatste woningen ophalen en toevoegen aan de database.
        </p>
        <button
          style={{ ...s.btnPrimary, ...(importing ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }}
          onClick={handleImport}
          disabled={importing}
          data-testid="import-button"
        >
          {importing ? 'Bezig met importeren...' : 'Start Import (max 10 woningen)'}
        </button>

        <div style={s.importInfo}>
          <h4 style={s.infoTitle}>Hoe werkt het?</h4>
          <ul style={s.infoList}>
            <li>Het systeem scraped automatisch de Nelemans website</li>
            <li>Alleen nieuwe woningen worden toegevoegd (duplicaten worden overgeslagen)</li>
            <li>Alle woninggegevens worden automatisch geëxtraheerd</li>
            <li>De externe link verwijst naar de originele Nelemans pagina</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ImportPanel;
